import './accounting.scss';
import { useEffect, useState } from 'react';
import { Spinner } from '../../components/spinner/spinner';
import { Typography } from '../../components/typography/typography';
import { Product } from '../../clients/quipli-service/product/product';
import { useAPI } from '../../clients/quipli-service/quipli-service-client';
import { toast } from '../../util/toasts';
import { useAccountingApiV1 } from '../../clients/quipli-service/accounting/accounting-api-v1';
import {
  GeneralLedgerAccount,
  ItemGeneralLedgerTransactionType,
  ItemType,
} from '../../clients/quipli-service/accounting/accounting';
import { ItemGeneralLedgerAccountInput } from './item-general-ledger-account-input';

export const ProductGeneralLedgerAccount = (props: { product: number | Product }) => {
  const [product, setProduct] = useState<Product>();
  const [accounts, setAccounts] = useState<GeneralLedgerAccount[] | undefined>();
  const [splitSaleRental, setSplitSaleRental] = useState<boolean>();
  const { listAccounts, getItemGeneralLedgerAccount } = useAccountingApiV1();
  const { getProduct } = useAPI();

  useEffect(() => {
    listAccounts()
      .then((accounts) => {
        setAccounts(accounts);
      })
      .catch((e) => {
        console.log(e);
        toast('Error fetching accounts', 'error');
      });
    const productId = typeof props.product === 'number' ? props.product : props.product.id;
    Promise.all([
      getItemGeneralLedgerAccount(ItemType.Product, productId.toString(), ItemGeneralLedgerTransactionType.Rental),
      getItemGeneralLedgerAccount(ItemType.Product, productId.toString(), ItemGeneralLedgerTransactionType.Sale),
      typeof props.product === 'number' ? getProduct(productId) : Promise.resolve(props.product),
    ]).then(([rentalIncomeAccount, saleIncomeAccount, product]) => {
      setSplitSaleRental(
        rentalIncomeAccount?.id !== saleIncomeAccount?.id ||
          (product.allowSale && !product.allowRent) ||
          (!product.allowSale && product.allowRent),
      );
      setProduct(product);
    });
  }, []);

  return (
    <div className="item-income-account container-v2">
      {accounts && product ? (
        <div className="flex flex-end flex-column" style={{ alignItems: 'flex-end' }}>
          {splitSaleRental ? (
            <>
              {product.allowRent && (
                <ItemGeneralLedgerAccountInput
                  itemType={ItemType.Product}
                  itemId={product.id.toString()}
                  transactionType={ItemGeneralLedgerTransactionType.Rental}
                  accounts={accounts}
                  label="Rental General Ledger Account"
                />
              )}
              {product.allowSale && (
                <ItemGeneralLedgerAccountInput
                  itemType={ItemType.Product}
                  itemId={product.id.toString()}
                  transactionType={ItemGeneralLedgerTransactionType.Sale}
                  accounts={accounts}
                  label="Sale General Ledger Account"
                />
              )}
            </>
          ) : (
            <>
              <ItemGeneralLedgerAccountInput
                itemType={ItemType.Product}
                itemId={product.id.toString()}
                accounts={accounts}
              />
              <Typography type={'text-xs'}>
                <a onClick={() => setSplitSaleRental(!splitSaleRental)}>Split Sale/Rental</a>
              </Typography>
            </>
          )}
          <ItemGeneralLedgerAccountInput
            itemType={ItemType.Product}
            itemId={product.id.toString()}
            transactionType={ItemGeneralLedgerTransactionType.Expense}
            accounts={accounts}
            label="Expense General Ledger Account"
          />
        </div>
      ) : (
        <Spinner />
      )}
    </div>
  );
};
